import { SectionHeaderStyled } from '../styles/SectionHeaderStyles';

const SectionHeader = ({ type, title, count, icon }) => {
  return (
    <SectionHeaderStyled className={type}>
      <h3>
        <i className={`${icon} section-icon`}></i>
        {title}
        <span className="section-count">{count}</span>
      </h3>
    </SectionHeaderStyled>
  );
};

export default SectionHeader;
